/* ══════════════════════════════════════════════════════════════════════
   IBERLUFFA — Chat Widget (módulo independiente)
   ──────────────────────────────────────────────────────────────────────
   Auto-se inyecta cuando carga. Para eliminarlo: borra este archivo y
   `chat-widget.css`, y quita las dos referencias en los .html. No usa ni
   modifica nada del resto del sitio.
   ══════════════════════════════════════════════════════════════════════ */
(function(){
  'use strict';

  if(document.getElementById('cwFab')) return;

  // ── CONFIGURACIÓN ──────────────────────────────────────────────────
  const CONFIG = {
    brandName: 'Iberluffa',
    brandTag: 'Esponjas 100% naturales · Galicia',
    logoMain:   'assets/images/logo/logo-oscurox3.png',
    chatAvatar: 'assets/images/logo/favicon.png',
    stories: [
      { img:'assets/images/instagram/ig-1.jpg', label:'Iberluffa', time:'hace 2 h' },
      { img:'assets/images/instagram/ig-2.jpg', label:'Iberluffa', time:'hace 5 h' },
      { img:'assets/images/instagram/ig-3.jpg', label:'Iberluffa', time:'hace 9 h' },
      { img:'assets/images/instagram/ig-4.jpg', label:'Iberluffa', time:'ayer'    }
    ],
    contacts: [
      { name:'Iberluffa',      img:'assets/images/logo/logo-oscurox2.png', phone:'+34600000000', preview:'¡Hola! Cuéntanos cómo podemos ayudarte', time:'9:42', unread:1 },
      { name:'Luffa-esponjas', img:'assets/images/logo/logo-oscurox3.png', phone:'+34600000001', preview:'Mayoristas: respondemos en 24h en horario laboral', time:'ayer', unread:0 }
    ],
    schedule: { days:[1,2,3,4,5], from:9, to:18 },
    contactFormUrl: (window.IB_LROOT||'') + '/pages/contacto',
    mayoristaUrl:   (window.IB_LROOT||'') + '/pages/contacto?form=mayorista',
    particularUrl:  (window.IB_LROOT||'') + '/pages/contacto?form=particular'
  };
  if(window.IB_RESOLVE){
    CONFIG.logoMain = IB_RESOLVE(CONFIG.logoMain);
    CONFIG.chatAvatar = IB_RESOLVE(CONFIG.chatAvatar);
    CONFIG.stories.forEach(function(s){ s.img = IB_RESOLVE(s.img); });
    CONFIG.contacts.forEach(function(c){ c.img = IB_RESOLVE(c.img); });
  }

  // ── i18n ───────────────────────────────────────────────────────────
  // Textos desde window.IB_CW (inyectado por iberluffa-i18n.liquid según idioma).
  // Fallback al español hardcodeado de arriba.
  const T = window.IB_CW || {};
  if(T.brand_tag) CONFIG.brandTag = T.brand_tag;
  if(T.story_times) CONFIG.stories.forEach(function(s,i){ if(T.story_times[i]) s.time = T.story_times[i]; });
  if(T.preview_particular && CONFIG.contacts[0]) CONFIG.contacts[0].preview = T.preview_particular;
  if(T.preview_mayorista && CONFIG.contacts[1]) CONFIG.contacts[1].preview = T.preview_mayorista;
  if(T.contact_time && CONFIG.contacts[1]) CONFIG.contacts[1].time = T.contact_time;

  // ── HELPERS ────────────────────────────────────────────────────────
  function isOpenNow(){
    const now = new Date();
    return CONFIG.schedule.days.indexOf(now.getDay()) !== -1
        && now.getHours() >= CONFIG.schedule.from
        && now.getHours() < CONFIG.schedule.to;
  }

  // ── ICONOS ─────────────────────────────────────────────────────────
  const ICO = {
    whatsapp: '<svg class="cw-wa" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.876 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413"/></svg>',
    close: '<svg viewBox="0 0 24 24" class="cw-close" xmlns="http://www.w3.org/2000/svg"><path d="M18 6 6 18M6 6l12 12" stroke="#fff" stroke-width="2.5" stroke-linecap="round" fill="none"/></svg>',
    closeX: '<svg viewBox="0 0 24 24"><path d="M18 6 6 18M6 6l12 12"/></svg>',
    phone: '<svg viewBox="0 0 24 24"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>',
    clock: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>',
    helpCircle: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>',
    mail: '<svg viewBox="0 0 24 24"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>',
    briefcase: '<svg viewBox="0 0 24 24"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>',
    user: '<svg viewBox="0 0 24 24"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>',
    chevron: '<svg class="cw-info-chevron" viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"/></svg>',
    arrowRight: '<svg viewBox="0 0 24 24"><path d="M5 12h14M12 5l7 7-7 7"/></svg>',
    novedades: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="4"/><path d="M21 7l-3 1M21 17l-3-1M3 7l3 1M3 17l3-1"/></svg>',
    llamadas:  '<svg viewBox="0 0 24 24"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>',
    chats:     '<svg viewBox="0 0 24 24"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8z"/></svg>',
    perfil:    '<svg viewBox="0 0 24 24"><circle cx="12" cy="8" r="4"/><path d="M4 21c0-4.4 3.6-8 8-8s8 3.6 8 8"/></svg>'
  };

  // ── HTML de los tabs ───────────────────────────────────────────────
  function tabNovedadesHTML(){
    return `
      <div class="cw-tab-panel cw-active" data-tab="novedades">
        <p class="cw-section-lbl">${T.updates || 'Actualizaciones recientes'}</p>
        ${CONFIG.stories.map((s,i) => `
          <div class="cw-status-row" data-story="${i}">
            <div class="cw-status-avatar cw-ring"><img src="${s.img}" alt="${s.label}"></div>
            <div class="cw-status-info">
              <p class="cw-status-name">${s.label}</p>
              <p class="cw-status-sub">${s.time}</p>
            </div>
          </div>
        `).join('')}
      </div>
    `;
  }
  function tabLlamadasHTML(){
    const statusText = isOpenNow()
      ? '<span class="cw-call-status cw-online">' + (T.available_now || 'Disponible ahora') + '</span>'
      : '<span class="cw-call-status cw-offline">' + (T.offline_calls || 'Te respondemos en horario L-V 9:00-18:00') + '</span>';
    return `
      <div class="cw-tab-panel" data-tab="llamadas">
        <p class="cw-section-lbl">${T.recent || 'Recientes'}</p>
        ${CONFIG.contacts.map(c => `
          <a class="cw-call-row" href="tel:${c.phone}">
            <div class="cw-call-avatar"><img src="${c.img}" alt="${c.name}"></div>
            <div class="cw-call-info">
              <p class="cw-call-name">${c.name}</p>
              <div class="cw-call-meta">${statusText}</div>
            </div>
            <button class="cw-call-btn" aria-label="${T.call_aria || 'Llamar a'} ${c.name}">${ICO.phone}</button>
          </a>
        `).join('')}
      </div>
    `;
  }
  function tabChatsHTML(){
    return `
      <div class="cw-tab-panel" data-tab="chats">
        ${CONFIG.contacts.map((c, i) => `
          <a class="cw-chat-row" href="${CONFIG.contactFormUrl}" data-chat="${i}">
            <div class="cw-chat-avatar"><img src="${CONFIG.chatAvatar}" alt="${c.name}"></div>
            <div class="cw-chat-info">
              <div class="cw-chat-top">
                <p class="cw-chat-name">${c.name}</p>
                <span class="cw-chat-time ${c.unread ? 'cw-unread':''}">${c.time}</span>
              </div>
              <div class="cw-chat-bottom">
                <p class="cw-chat-preview">${c.preview}</p>
                ${c.unread ? `<span class="cw-chat-badge">${c.unread}</span>` : ''}
              </div>
            </div>
          </a>
        `).join('')}
      </div>
    `;
  }
  function tabPerfilHTML(){
    const statusHTML = isOpenNow()
      ? '<span class="cw-call-status cw-online" style="font-size:13px">' + (T.attending_now || 'Atendiendo ahora') + '</span>'
      : '<span class="cw-call-status cw-offline" style="font-size:13px">' + (T.out_of_hours || 'Fuera de horario') + '</span>';
    return `
      <div class="cw-tab-panel" data-tab="perfil">
        <div class="cw-profile-head">
          <div class="cw-profile-avatar" data-action="open-avatar">
            <img src="${CONFIG.logoMain}" alt="${CONFIG.brandName}">
          </div>
          <h3 class="cw-profile-name">${CONFIG.brandName}</h3>
          <p class="cw-profile-tag">${CONFIG.brandTag}</p>
          <p class="cw-profile-tag" style="margin-top:6px">${statusHTML}</p>
        </div>
        <p class="cw-info-block-title">${T.info || 'Información'}</p>
        <div class="cw-info-block">
          <div class="cw-info-item">
            <div class="cw-info-ico">${ICO.clock}</div>
            <div class="cw-info-txt">
              <p class="cw-info-h">${T.hours_h || 'Horario de atención'}</p>
              <p class="cw-info-p">${T.hours_p || 'Lunes a viernes · 9:00 a 18:00 (CET)'}</p>
            </div>
          </div>
          <div class="cw-info-item">
            <div class="cw-info-ico">${ICO.mail}</div>
            <div class="cw-info-txt">
              <p class="cw-info-h">${T.response_h || 'Tiempo de respuesta'}</p>
              <p class="cw-info-p">${T.response_p || 'Solemos contestar en menos de 24h en horario laboral'}</p>
            </div>
          </div>
        </div>
        <p class="cw-info-block-title">${T.contact_us || 'Contáctanos'}</p>
        <div class="cw-info-block">
          <a class="cw-info-item" href="${CONFIG.particularUrl}">
            <div class="cw-info-ico">${ICO.user}</div>
            <div class="cw-info-txt">
              <p class="cw-info-h">${T.individual_h || 'Soy particular'}</p>
              <p class="cw-info-p">${T.individual_p || 'Abrir el formulario de contacto'}</p>
            </div>
            ${ICO.chevron}
          </a>
          <a class="cw-info-item" href="${CONFIG.mayoristaUrl}">
            <div class="cw-info-ico">${ICO.briefcase}</div>
            <div class="cw-info-txt">
              <p class="cw-info-h">${T.wholesale_h || 'Soy mayorista'}</p>
              <p class="cw-info-p">${T.wholesale_p || 'Pide presupuesto para tu tienda'}</p>
            </div>
            ${ICO.chevron}
          </a>
          <a class="cw-info-item" href="${CONFIG.contactFormUrl}" data-action="open-faq">
            <div class="cw-info-ico">${ICO.helpCircle}</div>
            <div class="cw-info-txt">
              <p class="cw-info-h">${T.faq_h || 'Preguntas frecuentes'}</p>
              <p class="cw-info-p">${T.faq_p || 'Resuelve dudas sin esperar respuesta'}</p>
            </div>
            ${ICO.chevron}
          </a>
        </div>
      </div>
    `;
  }
  function experimentalOverlayHTML(){
    return `
      <div class="cw-experimental cw-vis" id="cwExperimental">
        <button type="button" class="cw-exp-close" id="cwExpClose" aria-label="Cerrar widget">
          <svg viewBox="0 0 24 24"><path d="M18 6 6 18M6 6l12 12"/></svg>
        </button>
        <span class="cw-exp-badge">Experimental</span>
        <h3 class="cw-exp-title">Widget de prueba<br><strong>moira.creativa</strong></h3>
        <p class="cw-exp-text">Este widget es un experimento de <strong>moira.creativa</strong>. Es algo que puede tener tu web en caso de que os guste. Un punto de contacto rápido tipo WhatsApp con novedades, llamadas, chats y perfil.</p>
        <button type="button" class="cw-exp-btn" id="cwExpBtn">
          Ver widget ${ICO.arrowRight}
        </button>
        <p class="cw-exp-author">Diseñado por <strong>moira.creativa</strong></p>
      </div>
    `;
  }
  function buildPanelHTML(){
    return `
      <div class="cw-header">
        <div class="cw-header-l">
          <button class="cw-icon-btn cw-close-btn" id="cwCloseBtn" aria-label="${T.close || 'Cerrar'}">${ICO.closeX}</button>
        </div>
        <div class="cw-header-c">
          <h2 id="cwHeaderTitle">Chats</h2>
        </div>
        <div class="cw-header-r" aria-hidden="true">
          <span style="width:34px;height:34px;display:inline-block"></span>
        </div>
      </div>
      <div class="cw-body">
        ${tabChatsHTML()}
        ${tabNovedadesHTML().replace('cw-active','')}
        ${tabLlamadasHTML()}
        ${tabPerfilHTML()}
      </div>
      <div class="cw-bottomnav">
        <button class="cw-tab-btn" data-tab="novedades">
          ${ICO.novedades}<span>${T.tab_updates || 'Novedades'}</span>
        </button>
        <button class="cw-tab-btn" data-tab="llamadas">
          ${ICO.llamadas}<span>${T.tab_calls || 'Llamadas'}</span>
        </button>
        <button class="cw-tab-btn cw-active" data-tab="chats">
          ${ICO.chats}<span>${T.tab_chats || 'Chats'}</span>
          ${CONFIG.contacts.reduce((s,c)=>s+(c.unread||0),0) > 0 ? `<span class="cw-tab-badge">${CONFIG.contacts.reduce((s,c)=>s+(c.unread||0),0)}</span>` : ''}
        </button>
        <button class="cw-tab-btn" data-tab="perfil">
          ${ICO.perfil}<span>${T.tab_profile || 'Perfil'}</span>
        </button>
      </div>
    `;
  }

  // ── INYECCIÓN ──────────────────────────────────────────────────────
  const fab = document.createElement('button');
  fab.className = 'cw-fab';
  fab.id = 'cwFab';
  fab.setAttribute('aria-label', T.fab_open || 'Abrir chat de atención');
  fab.innerHTML = ICO.whatsapp + ICO.close;

  const backdrop = document.createElement('div');
  backdrop.className = 'cw-backdrop';
  backdrop.id = 'cwBackdrop';

  const panel = document.createElement('div');
  panel.className = 'cw-panel';
  panel.id = 'cwPanel';
  panel.setAttribute('role','dialog');
  panel.setAttribute('aria-modal','true');
  panel.innerHTML = buildPanelHTML();

  const lightbox = document.createElement('div');
  lightbox.className = 'cw-lightbox';
  lightbox.id = 'cwLightbox';
  lightbox.innerHTML = '<button class="cw-lightbox-close" aria-label="' + (T.close_img || 'Cerrar imagen') + '"><svg viewBox="0 0 24 24"><path d="M18 6 6 18M6 6l12 12" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round"/></svg></button><img id="cwLightboxImg" alt="">';

  function mount(){
    document.body.appendChild(fab);
    document.body.appendChild(backdrop);
    document.body.appendChild(panel);
    document.body.appendChild(lightbox);
    bindEvents();
    showTab('chats');
    setupOverlayWatcher();
  }

  // Fallback para navegadores sin :has() — observa cambios de clase en los
  // overlays y oculta el FAB cuando alguno esté abierto.
  function setupOverlayWatcher(){
    // Si el navegador soporta :has(), no hace falta el watcher (lo gestiona el CSS)
    try {
      if(window.CSS && CSS.supports && CSS.supports('selector(:has(*))')) return;
    } catch(_){}
    const watched = ['.cart-drawer','.user-panel','.info-popup','.faq-modal','.srch-overlay','.mob-drawer','.welcome-modal','#fdDrawer'];
    function refresh(){
      let anyOpen = false;
      watched.forEach(sel => {
        const el = document.querySelector(sel);
        if(!el) return;
        const cs = el.className || '';
        if(cs.indexOf('open') !== -1 || cs.indexOf('faq-open') !== -1) anyOpen = true;
      });
      fab.classList.toggle('cw-overlay-hidden', anyOpen);
    }
    const mo = new MutationObserver(refresh);
    mo.observe(document.body, { attributes:true, subtree:true, attributeFilter:['class'] });
    refresh();
  }

  // ── LÓGICA ─────────────────────────────────────────────────────────
  function openPanel(){
    panel.classList.add('cw-open');
    backdrop.classList.add('cw-vis');
    fab.classList.add('cw-open');
    fab.setAttribute('aria-label', T.fab_close || 'Cerrar chat');
    if(window.innerWidth <= 768) document.body.style.overflow = 'hidden';
  }
  function closePanel(){
    panel.classList.remove('cw-open');
    backdrop.classList.remove('cw-vis');
    fab.classList.remove('cw-open');
    fab.setAttribute('aria-label', T.fab_open || 'Abrir chat de atención');
    document.body.style.overflow = '';
  }
  function togglePanel(){
    if(panel.classList.contains('cw-open')) closePanel();
    else openPanel();
  }
  function dismissExperimental(){
    const exp = document.getElementById('cwExperimental');
    if(exp){
      exp.classList.add('cw-hide');
      exp.classList.remove('cw-vis');
    }
  }

  function showTab(name){
    panel.querySelectorAll('.cw-tab-panel').forEach(t => {
      t.classList.toggle('cw-active', t.getAttribute('data-tab') === name);
    });
    panel.querySelectorAll('.cw-tab-btn').forEach(b => {
      b.classList.toggle('cw-active', b.getAttribute('data-tab') === name);
    });
    const titles = {
      novedades: T.tab_updates || 'Novedades',
      llamadas:  T.tab_calls   || 'Llamadas',
      chats:     T.tab_chats   || 'Chats',
      perfil:    T.tab_profile  || 'Perfil'
    };
    const t = document.getElementById('cwHeaderTitle');
    if(t) t.textContent = titles[name] || (T.tab_chats || 'Chats');
    const body = panel.querySelector('.cw-body');
    if(body) body.scrollTop = 0;
  }

  function openLightbox(src){
    const img = document.getElementById('cwLightboxImg');
    if(img) img.src = src;
    lightbox.classList.add('cw-vis');
  }
  function closeLightbox(){ lightbox.classList.remove('cw-vis'); }

  function bindEvents(){
    fab.addEventListener('click', e => { e.stopPropagation(); togglePanel(); });
    backdrop.addEventListener('click', closePanel);

    const close = panel.querySelector('#cwCloseBtn');
    if(close) close.addEventListener('click', closePanel);

    const expBtn = panel.querySelector('#cwExpBtn');
    if(expBtn) expBtn.addEventListener('click', dismissExperimental);

    const expClose = panel.querySelector('#cwExpClose');
    if(expClose) expClose.addEventListener('click', closePanel);

    panel.querySelectorAll('.cw-tab-btn').forEach(btn => {
      btn.addEventListener('click', () => showTab(btn.getAttribute('data-tab')));
    });

    panel.querySelectorAll('[data-story]').forEach(row => {
      row.addEventListener('click', () => {
        const idx = parseInt(row.getAttribute('data-story'), 10);
        const s = CONFIG.stories[idx];
        if(s) openLightbox(s.img);
      });
    });

    const avatarBtn = panel.querySelector('[data-action="open-avatar"]');
    if(avatarBtn) avatarBtn.addEventListener('click', () => openLightbox(CONFIG.logoMain));

    // FAQ: prioriza el popup FAQ específico si existe, si no, el info popup
    const faqLink = panel.querySelector('[data-action="open-faq"]');
    if(faqLink){
      faqLink.addEventListener('click', e => {
        if(typeof window.openFaqPopup === 'function'){
          e.preventDefault();
          closePanel();
          setTimeout(() => window.openFaqPopup(), 280);
        } else if(typeof window.openInfoPopup === 'function'){
          e.preventDefault();
          closePanel();
          setTimeout(() => window.openInfoPopup(T.faq_h || 'Preguntas frecuentes'), 280);
        }
      });
    }

    lightbox.addEventListener('click', e => {
      if(e.target === lightbox || e.target.closest('.cw-lightbox-close')) closeLightbox();
    });

    document.addEventListener('keydown', e => {
      if(e.key !== 'Escape') return;
      if(lightbox.classList.contains('cw-vis')) closeLightbox();
      else if(panel.classList.contains('cw-open')) closePanel();
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }
})();
